import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { Tabs, Input } from 'antd';
import { injectIntl } from 'react-intl';
import BudgetInformation from './BudgetInformation';
import styles from './BudgetRequests.module.scss';
import {
  jobUsageBudgetRequests,
  jobUsageTotalBudgetRequests,
  userBudgetRequests,
  userTotalBudgetRequests,
} from '../../../../Reducers/BudgetCappingReducer';
import { getApiStatus } from '../../../../Reducers/ApiStatusReducer';
import * as JobLevelLimitActions from '../../../../Actions/BudgetCappingActions';
import messages from '../../../ManualSearchV2/ManualSearchMessages';
import { getFeatureToggleList } from '../../../../Reducers/FeatureToggleReducer';

const { TabPane } = Tabs;
const { Search } = Input;

const mapStateToProps = state => ({
  jobCreditsRequests: jobUsageBudgetRequests(state),
  jobTotalRequests: jobUsageTotalBudgetRequests(state),
  jobCreditsApiStatus: getApiStatus(state, 'jobUsageBudgetRequestsApiStatus'),
  userBudgetRequests: userBudgetRequests(state),
  userTotalRequests: userTotalBudgetRequests(state),
  featureToggleList: getFeatureToggleList(state),
});

const mapDispatchToProps = {
  fetchAllJobUsageBudgetRequests: JobLevelLimitActions.fetchAllJobUsageBudgetRequests,
  updateBudgetRequestStatus: JobLevelLimitActions.updateBudgetRequestStatus,
  fetchAllUserBudgetRequests: JobLevelLimitActions.fetchAllUserBudgetRequests,
};

function BudgetRequests(props) {
  const {
    jobCreditsRequests,
    jobTotalRequests,
    jobCreditsApiStatus,
    fetchAllJobUsageBudgetRequests,
    updateBudgetRequestStatus,
    intl,
    userBudgetRequests,
    userTotalRequests,
    fetchAllUserBudgetRequests,
    featureToggleList,
  } = props;
  const [activeTab, setActiveTab] = useState(null);
  const [searchTerm, setSearchTerm] = useState(null);
  const [currentAppliedFilter, setCurrentAppliedFilter] = useState(null);
  const [page, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const isJobUsageBudgetEnabled = featureToggleList.JobUsageBudget.IsEnabled;
  const isUserBudgetCappingEnabled = featureToggleList.UserBudgetCapping.IsEnabled;

  const handleTabChange = activeKey => {
    setActiveTab(activeKey);
    setSearchTerm(null);
    setCurrentAppliedFilter(null);
    setPageNumber(1);
    setPageSize(10);
  };

  const handleSearchTerm = event => {
    const searchKeyword = event.target.value;
    setPageNumber(1);
    setSearchTerm(searchKeyword);
    if (!searchKeyword) {
      const currentFilter = { ...currentAppliedFilter, SearchKeyword: null };
      setCurrentAppliedFilter(currentFilter);
      if (activeTab === 'jobCredits') {
        fetchAllJobUsageBudgetRequests(currentFilter, pageSize);
      } else {
        fetchAllUserBudgetRequests(currentFilter, pageSize);
      }
    }
  };

  const handleSearch = searchKeyword => {
    setPageNumber(1);
    const currentFilter = { ...currentAppliedFilter, SearchKeyword: searchKeyword };
    setCurrentAppliedFilter(currentFilter);
    if (activeTab === 'jobCredits') {
      fetchAllJobUsageBudgetRequests(currentFilter, pageSize);
    } else {
      fetchAllUserBudgetRequests(currentFilter, pageSize);
    }
  };

  useEffect(() => {
    if (isJobUsageBudgetEnabled) {
      fetchAllJobUsageBudgetRequests({ From: (page - 1) * pageSize, Size: pageSize });
    }
    if (isUserBudgetCappingEnabled) {
      fetchAllUserBudgetRequests({ From: (page - 1) * pageSize, Size: pageSize });
    }
    if (isJobUsageBudgetEnabled) {
      setActiveTab('jobCredits');
    } else if (isUserBudgetCappingEnabled) {
      setActiveTab('userCredits');
    }
  }, []);

  return (
    <div className={styles.budgetRequestsWrapper}>
      <div className={styles.headerSection}>
        <h1 className={styles.title}>Credit Information</h1>
      </div>

      <div className={styles.tabsContainer}>
        <div className={styles.tabsWithSearch}>
          <Tabs activeKey={activeTab} onChange={handleTabChange} className={styles.creditsTabs}>
            {isJobUsageBudgetEnabled && <TabPane tab="Job Credits" key="jobCredits" />}
            {isUserBudgetCappingEnabled && <TabPane tab="User Credits" key="userCredits" />}
          </Tabs>
          <div className={styles.searchBox}>
            <Search
              placeholder={intl.formatMessage({ ...messages.searchJobLabel })}
              onSearch={value => handleSearch(value)}
              onChange={handleSearchTerm}
              value={searchTerm}
              allowClear
              className={styles.searchInput}
            />
          </div>
        </div>

        {activeTab === 'jobCredits' ? (
          <BudgetInformation
            creditsRequests={jobCreditsRequests}
            totalRequests={jobTotalRequests}
            CreditsRequestsApiStatus={jobCreditsApiStatus}
            fetchAllJobUsageBudgetRequests={fetchAllJobUsageBudgetRequests}
            updateBudgetRequestStatus={updateBudgetRequestStatus}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            currentAppliedFilter={currentAppliedFilter}
            setCurrentAppliedFilter={setCurrentAppliedFilter}
            page={page}
            setPageNumber={setPageNumber}
            pageSize={pageSize}
            setPageSize={setPageSize}
            activeTab={activeTab}
          />
        ) : (
          <BudgetInformation
            creditsRequests={userBudgetRequests}
            totalRequests={userTotalRequests}
            CreditsRequestsApiStatus={jobCreditsApiStatus}
            updateBudgetRequestStatus={updateBudgetRequestStatus}
            setSearchTerm={setSearchTerm}
            searchTerm={searchTerm}
            currentAppliedFilter={currentAppliedFilter}
            setCurrentAppliedFilter={setCurrentAppliedFilter}
            page={page}
            setPageNumber={setPageNumber}
            pageSize={pageSize}
            setPageSize={setPageSize}
            activeTab={activeTab}
            fetchAllUserBudgetRequests={fetchAllUserBudgetRequests}
          />
        )}
      </div>
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BudgetRequests));
